<template>
    <el-dialog
            :visible.sync="dialog"
            :close-on-press-escape="false"
            :before-close="handleClose"
            width="30%">
        <el-card class="box-card" style="margin:10px 0;">

            <div class="text item">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentType')}}</span>
                <span style="text-transform: uppercase;" v-if="selectedRow.docType === 'healthsafety'"> Health & safety</span>
                <span style="text-transform: uppercase;" v-else-if="selectedRow.docType === 'envirenmental'">General</span>
                <span style="text-transform: uppercase;" v-else-if="selectedRow.docType === 'riskAssesment'">Commercial</span>
                <span style="text-transform: uppercase;" v-else> {{selectedRow.docType}}</span>
            </div>
            <el-divider></el-divider>

            <div class="text item">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentTitle')}}</span> {{selectedRow.name}}
            </div>
            <el-divider></el-divider>

            <!--SOP-->
            <div class="text item" v-if="selectedRow.docType === 'sop'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentNo')}}</span>{{documents.sop.number}}
            </div>
            <!--POLICY-->
            <div class="text item" v-if="selectedRow.docType === 'policy'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentNo')}}</span> {{documents.policy.number}}
            </div>
            <!--HEALTH SAFETY-->
            <div class="text item" v-if="selectedRow.docType === 'healthsafety'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentNo')}}</span> {{documents.healthsafety.number}}
            </div>
            <!--RISK ASSESMENT COMMERCIAL-->
            <div class="text item" v-if="selectedRow.docType === 'riskAssesment' || selectedRow.docType === 'commercial'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentNo')}}</span> {{documents.riskAssesment.number}}
            </div>
            <!--ENVIRIMENTAL GENERAL-->
            <div class="text item" v-if="selectedRow.docType === 'envirenmental' || selectedRow.docType === 'general'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_documentNo')}}</span> {{documents.envirenmental.number}}
            </div>
            <el-divider></el-divider>

            <!--SOP-->
            <div class="text item" v-if="selectedRow.docType === 'sop'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_revisionNo')}}</span>{{documents.sop.revision}}
            </div>
            <!--POLICY-->
            <div class="text item" v-if="selectedRow.docType === 'policy'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_revisionNo')}}</span> {{documents.policy.revision}}
            </div>
            <!--HEALTH SAFETY-->
            <div class="text item" v-if="selectedRow.docType === 'healthsafety'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_revisionNo')}}</span> {{documents.healthsafety.revision}}
            </div>
            <!--RISK ASSESMENT COMMERCIAL-->
            <div class="text item" v-if="selectedRow.docType === 'riskAssesment' || selectedRow.docType === 'commercial'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_revisionNo')}}</span> {{documents.riskAssesment.revision}}
            </div>
            <!--ENVIRIMENTAL GENERAL-->
            <div class="text item" v-if="selectedRow.docType === 'envirenmental' || selectedRow.docType === 'general'">
                <span class="box-card_title">{{$t('modal_documentManagment_status_revisionNo')}}</span> {{documents.envirenmental.revision}}
            </div>
        </el-card>

        <div v-if="selectedRow.docType === 'sop'" class="item">
            <div v-if="documents.sop.editMessage" class="item__note">
                <!-- <el-alert
                        :title="$t('modal_documentManagment_status_revisionNotes')"
                        type="warning"
                        :description="documents.sop.editMessage"
                        show-icon>
                </el-alert> -->

                <el-collapse v-model="activeName" accordion>
                  <el-collapse-item :title="$t('modal_documentManagment_status_revisionNotes')" name="1">
                    <div>{{documents.sop.editMessage}}</div>
                  </el-collapse-item>
                </el-collapse>
            </div>
            <div class="item__title">
                <div v-if="documents.sop.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('project_tab_documents_accept')}}</el-tag>
                </div>
                <div v-if="documents.sop.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('project_tab_documents_reject')}}</el-tag>
                </div>
            </div>
            <div v-html="documents.sop.content" class="item__content"></div>

            <h4 v-if="documents.sop.files.length">{{$t('modal_documentManagment_attachments')}}</h4>

            <el-dropdown placement="bottom" v-for="item in documents.sop.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.originalName}}</span>
                  </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url, item)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item @click.native="downloadFiles(item.url, item.originalName)" class="download-btn" icon="el-icon-upload">{{$t('project_tab_files_first_download')}}</el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                </el-dropdown-menu>
            </el-dropdown>

            <!--<div v-for="item in documents.sop.files" :key="item.id" class="item__file">-->
                <!--<i class="el-icon-link"></i>-->
                <!--<a :href="`${item.url}?mode=attachment`"> {{item.name}}</a>-->
            <!--</div>-->

        </div>

        <div v-if="selectedRow.docType === 'policy'" class="item">
            <div v-if="documents.policy.editMessage" class="item__note">
                <!-- <el-alert
                        :title="$t('modal_documentManagment_status_revisionNotes')"
                        type="warning"
                        :description="documents.policy.editMessage"
                        show-icon>
                </el-alert> -->

                <el-collapse v-model="activeName" accordion>
                  <el-collapse-item :title="$t('modal_documentManagment_status_revisionNotes')" name="1">
                    <div>{{documents.policy.editMessage}}</div>
                  </el-collapse-item>
                </el-collapse>
            </div>
            <div class="item__title">
                <!--{{documents.policy.name}}-->
                <div v-if="documents.policy.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('project_tab_documents_accept')}}</el-tag>
                </div>
                <div v-if="documents.policy.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('project_tab_documents_reject')}}</el-tag>
                </div>
            </div>
            <div v-html="documents.policy.content" class="item__content"></div>

            <h4 v-if="documents.policy.files.length">{{$t('modal_documentManagment_attachments')}}</h4>

            <el-dropdown placement="bottom" v-for="item in documents.policy.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.originalName}}</span>
                  </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url, item)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item @click.native="downloadFiles(item.url, item.originalName)" class="download-btn" icon="el-icon-upload">{{$t('project_tab_files_first_download')}}</el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                </el-dropdown-menu>
            </el-dropdown>

            <!--<div v-for="item in documents.policy.files" :key="item.id" class="item__file">-->
                <!--<i class="el-icon-link"></i>-->
                <!--<a :href="`${item.url}?mode=attachment`"> {{item.name}}</a>-->
            <!--</div>-->
        </div>

        <div v-if="selectedRow.docType === 'healthsafety'" class="item">
            <div v-if="documents.healthsafety.editMessage" class="item__note">
                <!-- <el-alert
                        :title="$t('modal_documentManagment_status_revisionNotes')"
                        type="warning"
                        :description="documents.healthsafety.editMessage"
                        show-icon>
                </el-alert> -->

                <el-collapse v-model="activeName" accordion>
                  <el-collapse-item :title="$t('modal_documentManagment_status_revisionNotes')" name="1">
                    <div>{{documents.healthsafety.editMessage}}</div>
                  </el-collapse-item>
                </el-collapse>
            </div>
            <div class="item__title">
                <!--{{documents.healthsafety.name}}-->
                <div v-if="documents.healthsafety.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('project_tab_documents_accept')}}</el-tag>
                </div>
                <div v-if="documents.healthsafety.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('project_tab_documents_reject')}}</el-tag>
                </div>
            </div>
            <div v-html="documents.healthsafety.content" class="item__content"></div>

            <h4 v-if="documents.healthsafety.files.length">{{$t('modal_documentManagment_attachments')}}</h4>

            <el-dropdown placement="bottom" v-for="item in documents.healthsafety.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.originalName}}</span>
                  </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url, item)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item @click.native="downloadFiles(item.url, item.originalName)" class="download-btn" icon="el-icon-upload">{{$t('project_tab_files_first_download')}}</el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <div v-if="selectedRow.docType === 'riskAssesment' || selectedRow.docType === 'commercial'" class="item">
            <div v-if="documents.riskAssesment.editMessage" class="item__note">
                <!-- <el-alert
                        :title="$t('modal_documentManagment_status_revisionNotes')"
                        type="warning"
                        :description="documents.riskAssesment.editMessage"
                        show-icon>
                </el-alert> -->

                <el-collapse v-model="activeName" accordion>
                  <el-collapse-item :title="$t('modal_documentManagment_status_revisionNotes')" name="1">
                    <div>{{documents.riskAssesment.editMessage}}</div>
                  </el-collapse-item>
                </el-collapse>
            </div>
            <div class="item__title">
                <!--{{documents.riskAssesment.name}}-->
                <div v-if="documents.riskAssesment.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('project_tab_documents_accept')}}</el-tag>
                </div>
                <div v-if="documents.riskAssesment.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('project_tab_documents_reject')}}</el-tag>
                </div>
            </div>
            <div v-html="documents.riskAssesment.content" class="item__content"></div>

            <h4 v-if="documents.riskAssesment.files.length">{{$t('modal_documentManagment_attachments')}}</h4>

            <el-dropdown placement="bottom" v-for="item in documents.riskAssesment.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.originalName}}</span>
                  </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url, item)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item @click.native="downloadFiles(item.url, item.originalName)" class="download-btn" icon="el-icon-upload">{{$t('project_tab_files_first_download')}}</el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <div v-if="selectedRow.docType === 'envirenmental' || selectedRow.docType === 'general'" class="item">
            <div v-if="documents.envirenmental.editMessage" class="item__note">
                <!-- <el-alert
                        :title="$t('modal_documentManagment_status_revisionNotes')"
                        type="warning"
                        :description="documents.envirenmental.editMessage"
                        show-icon>
                </el-alert> -->

                <el-collapse v-model="activeName" accordion>
                  <el-collapse-item :title="$t('modal_documentManagment_status_revisionNotes')" name="1">
                    <div>{{documents.envirenmental.editMessage}}</div>
                  </el-collapse-item>
                </el-collapse>
            </div>
            <div class="item__title">
                <!--{{documents.envirenmental.name}}-->
                <div v-if="documents.envirenmental.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('project_tab_documents_accept')}}</el-tag>
                </div>
                <div v-if="documents.envirenmental.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('project_tab_documents_reject')}}</el-tag>
                </div>
            </div>
            <div v-html="documents.envirenmental.content" class="item__content"></div>

            <h4 v-if="documents.envirenmental.files.length">{{$t('modal_documentManagment_attachments')}}</h4>

            <el-dropdown placement="bottom" v-for="item in documents.envirenmental.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.originalName}}</span>
                  </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url, item)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item @click.native="downloadFiles(item.url, item.originalName)" class="download-btn" icon="el-icon-upload">{{$t('project_tab_files_first_download')}}</el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                </el-dropdown-menu>
            </el-dropdown>

        </div>

        <!--VIEWER-->
        <div v-if="viewerType == 1">
            <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
                <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
        </div>
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
    </el-dialog>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import Media from '@dongido/vue-viaudio'
  import fileImg from '../../../fileImg'
  import axios from 'axios'
  export default {
    name: "DocumentInfoModal",
    components: {
      SweetModal,
      fileImg,
      Media
    },
    computed: {

    },
    data(){
      return {
        activeName: '1',
        dialog: false,
        revisionNo:'',
        selectedRow: {},
        documents: {
          sop: {

          },
          policy: {

          },
          healthsafety: {

          },
          riskAssesment: {

          },
          envirenmental: {

          }
        },
        viewerType: 0,
        fileUrl: '',
        type: ''
      }
    },
    methods:{
      downloadFiles(url, name) {
        // document.location.href = `${url + '/' + name}?mode=attachment`;
        let restOfTheUrl = url.split('https://storage.totalflow.io/')[1] || ''
        // alert(restOfTheUrl)
        let newUrl = `https://storage.totalflow.io/d.php?${restOfTheUrl + '/' + encodeURIComponent(name)}`
        document.location.href = newUrl
      },
      async openModal(selectedRow) {
        try {
          this.selectedRow = selectedRow;
            console.log(selectedRow)
          let url = '';
          switch (selectedRow.docType) {
            case 'sop':
              url = `/api/v1/document/item?companyId=${this.$route.query.companyId}&documentId=${selectedRow.id}&documentType=sop`;
              break;
            case 'policy':
              url = `/api/v1/document/item?companyId=${this.$route.query.companyId}&documentId=${selectedRow.id}&documentType=policy`;
              break;
            case 'general':
            case 'envirenmental':
              url = `/api/v1/document/item?companyId=${this.$route.query.companyId}&documentId=${selectedRow.id}&documentType=environmental`;
              break;
            case 'healthsafety':
              url = `/api/v1/document/item?companyId=${this.$route.query.companyId}&documentId=${selectedRow.id}&documentType=healthNSafety`;
              break;
            case 'riskAssesment':
            case 'commercial':
              url = `/api/v1/document/item?companyId=${this.$route.query.companyId}&documentId=${selectedRow.id}&documentType=riskAssessment`;
              break;
          }

          this.getDocumentInfo(url)

        } catch (err) {
          console.log(err)
        }
      },
      getDocumentInfo(url){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(url)
          .then(response => {
            this.dialog = true;
            switch (this.selectedRow.docType) {
              case 'sop':
                this.documents.sop = response.data.item.length ? response.data.item[0] : response.data.item;
                break;
              case 'policy':
                this.documents.policy = response.data.item.length ? response.data.item[0] : response.data.item;
                break;
              case 'general':
              case 'envirenmental':
                this.documents.envirenmental = response.data.item.length ? response.data.item[0] : response.data.item;
                break;
              case 'healthsafety':
                this.documents.healthsafety = response.data.item.length ? response.data.item[0] : response.data.item;
                break;
              case 'riskAssesment':
              case 'commercial':
                this.documents.riskAssesment = response.data.item.length ? response.data.item[0] : response.data.item;
                // rename type
                break;
            }
            loader.hide()
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
      },
      handleClose(){
        this.dialog = false;
        this.selectedRow = {};
        this.documents = {
          sop: {
          },
          policy: {
          },
          healthsafety: {
          },
          riskAssesment: {
          },
          envirenmental: {
          }
        }
      },
      viewFile(url, file) {
        let win = null;
        console.log(file);
        let type = url.split(".").pop().toUpperCase();
        this.fileUrl = url;
        this.type = this.fileUrl.split(".").pop().toUpperCase();
        switch (type) {
          case "GIF":
          case "JPG":
          case "JPEG":
          case "PNG":
          case "BMP":
            this.viewerType = 2;
            setTimeout(() => {
              console.log("-----", this.$el);
              const viewer = this.$el.querySelector(".images").$viewer;
              viewer.show();
            }, 300);
            break;
          case "MOV":
          case "MP4":
            this.viewerType = 3;
            break;
          case "WMA":
          case "MP3":
          case "WAV":
          case "OGG":
          case "M4A":
            this.viewerType = 4;
            break;
          case "STEP":
          case "STP":
          case "IGES":
          case "IGS":
          case "BREP":
          case "STL":
          case "SAT":
          case "X_T":
          case "X_B":
          case "SLDPRT":
          case "DWG":
          case "DXF":
          case "DWF":
          case "HPGL":
          case "PLT":
          case "CGM":
          case "SVG":
          case "EMF":
          case "WMF":
            this.fileUrl =
              "https://sharecad.org/cadframe/load?url=" + this.fileUrl;
            setTimeout(() => {
              window.open(this.fileUrl);
            }, 300);
            break;
          case "PDF":
            window.open(this.fileUrl);
            break;
          case "DOC":
          case "DOCM":
          case "DOCX":
          case "DOT":
          case "DOTM":
          case "DOTX":
          case "EPUD":
          case "FODT":
          case "HTM":
          case "MHT":
          case "ODT":
          case "OTT":
          case "RTF":
          case "TXT":
          case "DJVU":
          case "XPS":
          case "CSV":
          case "FODS":
          case "ODS":
          case "OTS":
          case "XLS":
          case "XLSM":
          case "XLSX":
          case "XLT":
          case "XLTM":
          case "XLTX":
          case "FODP":
          case "ODP":
          case "OTP":
          case "POT":
          case "POTM":
          case "POTX":
          case "PPS":
          case "PPT":
          case "PPTM":
          case "PPTX":
            win = window.open(
              `https://view.officeapps.live.com/op/view.aspx?src=${file.url}`,
              "_blank"
            );
            win.focus();
            break;
          default:
            this.$message({
              type: "info",
              message: this.$t("general_fileFormatIsNotSupported"),
            });
            this.fileUrl = "";
            this.type = "";
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
    /deep/.el-dialog__body {
        padding-top:0 !important;
    }
    .el-divider--horizontal {
        margin: 8px 0 !important;
    }
    .box-card_title {
        color: #888;
        font-size: 16px;
    }
    .item {
        &__note {
            margin-bottom: 10px;
        }
        &__title {
            position: relative;
            font-size: 20px;
            color: #909399;
        }
        &__status {
            position: absolute;
            top: 10px;
            right: 10px;
        }
        &__content {
            margin-bottom: 10px;
        }
        &__file {
            margin-bottom: 10px;
            display: flex;
            justify-content: flex-start;
        }
        &__btn {
            display: flex;
            justify-content: flex-end;
        }
    }
    /deep/.download-btn{
        a{
            color:#606266;
            &:hover{
                color:#66b1ff;
            }
        }
    }
    /deep/ .el-collapse-item__header {
          padding-left: 10px !important;
          color: #E6A23C !important;
    }
    /deep/ .el-collapse-item__wrap {
          padding-left: 10px !important;
    }
    /deep/ .el-collapse-item__content {
          color: #000000 !important;
    }
</style>
